import { getAnalytics, isSupported } from "firebase/analytics";
import firebaseConfig from "../firebaseConfig";
import {
  app,
  auth,
  functions,
  FUNCTIONS_REGION,
} from "./authorityClient";
if (firebaseConfig.measurementId) {
  isSupported().then((supported) => {
    if (supported) {
      getAnalytics(app);
    } else if (process.env.NODE_ENV !== "production") {
      console.warn("Analytics is not supported in this environment.");
    }
  });
}
// Compatibility tombstone only. Browser Firestore authority is disabled; new
// callsites must use bounded private-authority APIs from authorityClient.
const db = null;
const firestoreCacheMode = "disabled-private-authority";

export { app, db, auth, functions };
export { FUNCTIONS_REGION, firestoreCacheMode };
